/**
 * Calendar API - Autonomous calendar event module
 * @module api/calendar
 */

import { apiRequest, API_BASE_URL } from './core.js';

export const calendarAPI = {
  getEvents: (params = {}) => {
    const qs = new URLSearchParams(params).toString();
    return apiRequest(`/calendar/events${qs ? `?${qs}` : ''}`);
  },

  createEvent: (event) => apiRequest('/calendar/events', {
    method: 'POST',
    body: JSON.stringify(event),
  }),

  updateEvent: (id, event) => apiRequest(`/calendar/events/${id}`, {
    method: 'PUT',
    body: JSON.stringify(event),
  }),

  deleteEvent: (id) => apiRequest(`/calendar/events/${id}`, {
    method: 'DELETE',
  }),

  sync: () => apiRequest('/calendar/sync', { method: 'POST' }),

  getSources: () => apiRequest('/calendar/sources'),

  getExportUrl: (params = {}) => {
    const qs = new URLSearchParams({ ...params }).toString();
    return `${API_BASE_URL}/calendar/export.ics${qs ? `?${qs}` : ''}`;
  },
};
